// Components.
import Layout from 'components/Layout/Layout'

// Services.
import pathService from 'lib/services/pixels-headless/paths'
import pageService from 'lib/services/pixels-headless/posts'

// Utils.
import { redirect404 } from 'lib/utils/redirect-404'

// Constants.
import { revalidate } from 'lib/constants/revalidate'
import { pageTemplatesToComponents } from 'lib/constants/templates'

/**
 * Get list of "pages" from CMS.
 * Will be mapped to use this page component.
 */
export async function getStaticPaths() {
  const paths = await pathService.getMultipartPathsByType('page')

  return {
    paths,
    fallback: 'blocking',
  }
}

/**
 * Get data for current page by url slug.
 */
export async function getStaticProps({
  params,
  preview = false,
  locale = false,
}) {
  const page = await pageService.getPost(
    params.page[params.page.length - 1],
    'page',
    preview,
    locale,
  )
  if (page.length === 0) {
    return redirect404()
  }

  return {
    props: {
      page,
      preview,
    },
    revalidate,
  }
}

export default function Page({ page, preview }) {
  // Get right template to use.
  const PageTemplate = pageTemplatesToComponents[page.template]

  return (
    <Layout data={page} preview={preview}>
      <PageTemplate page={page} />
    </Layout>
  )
}
